<template>
  <div class="risk-inline-filters">
    <!-- Tipo de muestra -->
    <DxSelectBox
      :data-source="sampleTypes"
      display-expr="name"
      :value="selectedSampleTypes"
      :placeholder="$t('agronomySample.summary.sampleType')"
      :search-enabled="true"
      :on-value-changed="sampleTypesChanged"
      :show-clear-button="true"
      width="260"
    />

    <!-- País origen -->
    <DxSelectBox
      :data-source="originCountries"
      display-expr="name"
      :value="selectedOriginCountry"
      :placeholder="$t('originCountry')"
      :search-enabled="true"
      :on-value-changed="originCountriesChanged"
      :show-clear-button="true"
      width="260"
    />

    <!-- País destino -->
    <DxTagBox
      :data-source="destinationCountries"
      display-expr="name"
      value-expr="code"
      :value="selectedDestinationCountries"
      :placeholder="$t('destinationCountry')"
      :search-enabled="true"
      :on-value-changed="destinationCountriesChanged"
      :show-selection-controls="true"
      width="auto"
      class="select-tagbox-scroll"
    />
  </div>
</template>

<script>
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxTagBox } from 'devextreme-vue/tag-box';
import { mapState, mapActions, mapGetters } from 'vuex';
import { ATCS_ES } from '../../../js/constants';

export default {
  name: 'RiskAnalysisInlineFilters',
  components: { DxSelectBox, DxTagBox },

  computed: {
    ...mapState('riskAnalysisFilter', [
      'selectedSampleTypes',
      'selectedOriginCountry',
      'selectedDestinationCountries',
    ]),
    ...mapState('riskAnalysis', [
      'sampleTypes',
      'originCountries',
      'destinationCountries',
    ]),
    ...mapGetters('user', ['userProfile']),
  },

  methods: {
    sampleTypesChanged(e) {
      this.setSelectedSampleTypes(e.value);
    },
    originCountriesChanged(e) {
      this.setSelectedOriginCountry(e.value);
    },
    destinationCountriesChanged(e) {
      this.setSelectedDestinationCountries(e.value);
    },

    ...mapActions('riskAnalysisFilter', [
      'setSelectedSampleTypes',
      'setSelectedOriginCountry',
      'setSelectedDestinationCountries',
    ]),
    ...mapActions('riskAnalysis', [
      'getSampleTypesSat',
      'getDestinationCountries',
    ]),
  },
};
</script>

<style scoped>
.risk-inline-filters {
  display: flex;
  gap: 12px;
  align-items: center;
}
.risk-inline-filters .dx-selectbox {
  min-width: 200px;
}

.risk-inline-filters .dx-tagbox {
  min-width: 260px;
}
.select-tagbox-scroll :deep(.dx-texteditor-container) {
  overflow-y: auto;
  margin-right: 6px;
}
</style>
